import { Component, ViewEncapsulation, Input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
    selector: 'agpr-shadow-dom-container',
    templateUrl: './shadow-dom-container.component.html',
    encapsulation: ViewEncapsulation.ShadowDom,
    standalone: false
})
export class ShadowDomContainerComponent {

    _customHtml: SafeHtml;

    /**
     * Only trusted html should be passed, as security is bypassed
     */
    @Input() set customHtml(customHtml: string) {
        this._customHtml = this.sanitizer.bypassSecurityTrustHtml(customHtml);
    }

    constructor(public sanitizer: DomSanitizer) {
    }
}
